import React from "react";
import { useState, useEffect } from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useFormik } from "formik";
import axios from "helpers/API";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import { parse, format } from "date-fns";
import { es } from "date-fns/locale";
import CustomSwitch from "form/CustomSwitch";
import ProgramacionDetalle from "./ProgramacionDetalle";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import { errorBackendMsg } from "helpers/helpers";
import { DatePicker } from "@material-ui/pickers";
import Aviso from "componentes/Aviso";
import TablaMaterialUI from "componentes/TablaMaterialUI";
import { InputLabel } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function ModuloListado({ recargarTabla, setRecargarTabla }) {
    const classes = useStyles();

    const consultaDefault = {
        bandaHorariaId: "",
        lugarId: "",
        servidorId: "",
        servicioId: "",
        fechaDesde: "",
        fechaHasta: "",
        activado: null,
    };
    const [lugarOpt, setLugarOpt] = useState([]);
    const [servidorOpt, setServidorOpt] = useState([]);
    const [servicioOpt, setServicioOpt] = useState([]);
    const [bandasHorariasOpt, setBandasHorariasOpt] = useState([]);
    const [fechaDesde, setFechaDesde] = useState(null);
    const [fechaHasta, setFechaHasta] = useState(null);
    const [cargandoLista, setCargandoLista] = useState(true);

    const [rows, setRows] = useState([]);
    const [muestraDetalle, setMuestraDetalle] = useState(false);
    const [ultimaConsultaRealizada, setUltimaConsultaRealizada] = useState({
        ...consultaDefault,
    });
    const [idProgramacion, setIdProgramacion] = useState(false);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);
    const [mensajeInfo, setMensajeInfo] = useState("");
    const [showInfo, setShowInfo] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [msgAviso, setMsgAviso] = useState(false);
    const [colorAviso, setColorAviso] = useState("info");

    // Modals
    const [idBorrar, setIdBorrar] = useState(null);
    const [modalBorrar, setModalBorrar] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [msgError, setMsgError] = useState("");
    const [modalExito, setModalExito] = useState(false);
    const [msgExito, setMsgExito] = useState("");

    const mostrarModalBorrar = (id) => {
        setIdBorrar(id);
        setModalBorrar(true);
    };

    // Para Documentacion El select no detecta los values booleanos

    const activaOpt = [
        {
            value: "",
            label: "Indistinto",
        },
        {
            value: true,
            label: "Activa",
        },
        {
            value: false,
            label: "Inactiva",
        },
    ];

    useEffect(() => {
        listarLugares();
        consultarProgramacion({
            ...consultaDefault,
        });
    }, []);

    useEffect(() => {
        if (recargarTabla) {
            listarLugares();
            consultarProgramacion({
                ...consultaDefault,
            });
            setRecargarTabla(false)
        }
    }, [recargarTabla]);

    const borrarProgramacion = () => {
        axios
            .post("/programaciones/eliminar", { id: idBorrar })
            .then(function (response) {
                if (response.data.error) {
                    setModalError(true);
                    setMsgError(response.data.msg);
                } else {
                    setModalExito(true);
                    setMsgExito(response.data.msg);
                    consultarProgramacion(ultimaConsultaRealizada);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const listarLugares = () => {
        axios
            .post("/generales/lugares/listarPorEtiqueta", {})
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    setLugarOpt(response.data);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const listarServicio = (lugarId) => {
        if (!lugarId) {
            return;
        }
        axios
            .post("/generales/servicios/listarPorEtiqueta", {
                lugarId: lugarId,
            })
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    setServicioOpt(response.data);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const listarServidores = (servicioId) => {
        axios
            .post("/servidores/listarPorEtiqueta", { servicioId: servicioId })
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    setServidorOpt(response.data);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const listarBandasHorarias = (servidorId) => {
        axios
            .post("/bandasHorarias/listarPorEtiqueta", {
                servidorId: servidorId,
            })
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    setBandasHorariasOpt(response.data);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const consultarProgramacion = (consulta) => {
        axios
            .post("/programaciones/listar", consulta)
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    setRows(response.data);
                    setCargandoLista(false);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const activacionAPI = (url, id) => {
        axios
            .post(url, { id: id })
            .then(function (response) {
                if (response.data.error) {
                    setAviso(true);
                    setMsgAviso(response.data.msg);
                    setColorAviso("danger");
                } else {
                    setAviso(true);
                    setMsgAviso(response.data.msg);
                    setColorAviso("info");
                }
            })
            .catch(function (error) {
                setAviso(true);
                setMsgAviso(error);
                setColorAviso("info");
            })
            .finally(function () {
                consultarProgramacion(ultimaConsultaRealizada);
            });
    };

    const formik = useFormik({
        initialValues: {
            bandaHorariaId: "",
            lugarId: "",
            servidorId: "",
            servicioId: "",
            fechaDesde: "",
            fechaHasta: "",
            activado: "",
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            setUltimaConsultaRealizada(values);
            consultarProgramacion(values);
        },
    });

    const formatoFecha = (fecha) => {
        if (!Boolean(fecha)) {
            return fecha;
        }
        return format(
            parse(fecha, "yyyy-MM-dd", new Date(), { locale: es }),
            "dd/MM/yyyy"
        );
    };

    const cambiarActiva = (activar, id) => {
        if (activar) {
            activacionAPI("/programaciones/activar", id);
        } else {
            activacionAPI("/programaciones/desactivar", id);
        }
    };

    const resetForm = () => {
        setFechaHasta(null);
        setFechaDesde(null);
        formik.handleReset();
        setUltimaConsultaRealizada({});
    };

    const parsearFechaADate = (fecha) => {
        const partes = fecha.split("/");
        const day = Number(partes[0]);
        const month = Number(partes[1]) - 1; // the month is 0-indexed
        const age = Number(partes[2]);
        return new Date(age, month, day);
    };

    /**
     * @param {String} name Nombre del atributo
     */
    const ordenarFechas = (param1, param2, name) => {
        let dato1 = param1.api.getCellValue(param1.id, name);
        let dato2 = param2.api.getCellValue(param2.id, name);
        return parsearFechaADate(dato1) - parsearFechaADate(dato2);
    };



    const columns = [
        { field: "id", headerName: "ID", hide: true },
        {
            field: "descripcion",
            headerName: "Banda Horaria",
            editable: false,
            flex: 0.2,
        },
        {
            field: "fechaDesde",
            headerName: "Fecha Desde",
            valueGetter: (params) => params.row.fechaDesde,
            sortComparator: (v1, v2, param1, param2) =>
                ordenarFechas(param1, param2, "fechaDesde"),
            editable: false,
            flex: 0.2,
        },
        {
            field: "fechaHasta",
            headerName: "Fecha Hasta",
            valueGetter: (params) => params.row.fechaHasta,
            sortComparator: (v1, v2, param1, param2) =>
                ordenarFechas(param1, param2, "fechaHasta"),
            editable: false,
            flex: 0.2,
        },
        {
            field: "detalle",
            headerName: "Detalle",
            flex: 0.1,
            renderCell: (params) => (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginLeft: 16 }}
                        onClick={() => {
                            setMuestraDetalle(true);
                            setIdProgramacion(params.row.id);
                        }}
                    >
                        Detalle
                    </Button>
                </strong>
            ),
        },
        {
            field: "activar",
            headerName: "Activa",
            flex: 0.1,
            renderCell: (params) => (
                <CustomSwitch
                    checked={params.row.activado}
                    hook={(flag) => {
                        cambiarActiva(flag, params.row.id);
                    }}
                />
            ),
        },
        {
            field: "eliminar",
            headerName: "Eliminar",
            flex: 0.1,
            renderCell: (data) => (
                <strong>
                    <Button
                        variant="contained"
                        size="small"
                        style={{
                            marginLeft: 16,
                            backgroundColor: "#CA0B00 ",
                            color: "white",
                        }}
                        onClick={() => mostrarModalBorrar(data.row.id)}
                    >
                        Borrar
                    </Button>
                </strong>
            ),
        },
    ];

    return (
        <>
            <ProgramacionDetalle
                show={muestraDetalle}
                id={idProgramacion}
                handleShow={(flag) => setMuestraDetalle(flag)}
            />

            <Grid item md={12}>
                {modalBorrar && (
                    <MsgConfirmacion
                        setVisible={setModalBorrar}
                        titulo="Borrar Programación"
                        msg={"¿Desea borrar la programación seleccionada?"}
                        aceptar={borrarProgramacion}
                    />
                )}
                {modalError && (
                    <MsgGenericoAlerta
                        setVisible={setModalError}
                        titulo="Error"
                        msg={msgError}
                    />
                )}
                {modalExito && (
                    <MsgGenericoAlerta
                        setVisible={setModalExito}
                        titulo="Info"
                        msg={msgExito}
                    />
                )}
                <APIMensajeMUI
                    mb={30}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <APIMensajeMUI
                    mb={30}
                    tipo="info"
                    showMensaje={showInfo}
                    msg={mensajeInfo}
                />
                <Aviso
                    onClose={() => setAviso(false)}
                    mostrar={aviso}
                    msg={msgAviso}
                    color={colorAviso}
                />
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="filtros"
                        id="filtros"
                    >
                        <Typography variant="h5">
                            <strong>Filtros</strong>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item md={4}>
                                <SelectFieldMaterialUI
                                    classNameFormControl={
                                        classes.inputNuevaBanda
                                    }
                                    editar={false}
                                    name="lugarId"
                                    nombreLabel="Lugar"
                                    hijosDirectos={["servicioId"]}
                                    formik={formik}
                                    itemsArray={lugarOpt}
                                    ejecutarAccion={(id) => {
                                        listarServicio(id);
                                    }}
                                />
                            </Grid>

                            <Grid item md={4}>
                                <SelectFieldMaterialUI
                                    classNameFormControl={
                                        classes.inputNuevaBanda
                                    }
                                    editar={false}
                                    name="servicioId"
                                    hijosDirectos={["servidorId"]}
                                    nombreLabel="Servicio"
                                    formik={formik}
                                    itemsArray={servicioOpt}
                                    reiniciarItemsArray={setServicioOpt}
                                    ejecutarAccion={(id) =>
                                        listarServidores(id)
                                    }
                                    arrayPadreListener={lugarOpt}
                                    peticionParaCargarOpcionesAutomatica={(
                                        id
                                    ) => listarServicio(id)}
                                />
                            </Grid>
                            <Grid item md={4} />

                            <Grid item md={4}>
                                <SelectFieldMaterialUI
                                    classNameFormControl={
                                        classes.inputNuevaBanda
                                    }
                                    name="servidorId"
                                    editar={false}
                                    hijosDirectos={["bandaHorariaId"]}
                                    nombreLabel="Servidor"
                                    formik={formik}
                                    itemsArray={servidorOpt}
                                    reiniciarItemsArray={setServidorOpt}
                                    ejecutarAccion={(id) =>
                                        listarBandasHorarias(id)
                                    }
                                    arrayPadreListener={servicioOpt}
                                    peticionParaCargarOpcionesAutomatica={(
                                        id
                                    ) => listarServidores(id)}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <SelectFieldMaterialUI
                                    classNameFormControl={
                                        classes.inputNuevaBanda
                                    }
                                    name="bandaHorariaId"
                                    editar={false}
                                    nombreLabel="Banda Horaria"
                                    formik={formik}
                                    itemsArray={bandasHorariasOpt}
                                    reiniciarItemsArray={setBandasHorariasOpt}
                                    arrayPadreListener={servidorOpt}
                                    peticionParaCargarOpcionesAutomatica={(
                                        id
                                    ) => listarBandasHorarias(id)}
                                />
                            </Grid>
                            <Grid item md={4} style={{ marginTop: "-1.75em" }}>
                                <InputLabel>
                                    <small>Estado</small>
                                </InputLabel>
                                <SelectFieldMaterialUI
                                    classNameFormControl={
                                        classes.inputNuevaBanda
                                    }
                                    name="activado"
                                    editar={false}
                                    nombreLabel="Estado"
                                    showLabel={false}
                                    formik={formik}
                                    itemsArray={activaOpt}
                                    displayEmpty
                                />
                            </Grid>

                            <Grid item md={4}>
                                <Grid
                                    container
                                    justifyContent="center"
                                    alignContent="center"
                                >
                                    <Grid item md={10}>
                                        <DatePicker
                                            autoOk
                                            className={classes.inputNuevaBanda}
                                            name="fechaDesde"
                                            id="fechaDesde"
                                            value={fechaDesde}
                                            label="Fecha Desde"
                                            format="dd/MM/yyyy"
                                            inputVariant="outlined"
                                            onChange={(fecha) => {
                                                setFechaDesde(fecha);
                                                formik.setFieldValue(
                                                    "fechaDesde",
                                                    format(fecha, "dd/MM/yyyy")
                                                );
                                            }}
                                            disableToolbar
                                            variant="inline"
                                        />
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            onClick={() => {
                                                setFechaDesde(null);
                                                formik.setFieldValue(
                                                    "fechaDesde",
                                                    ""
                                                );
                                            }}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                            variant="contained"
                                        >
                                            X
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={4}>
                                <Grid
                                    container
                                    justifyContent="center"
                                    alignContent="center"
                                >
                                    <Grid item md={10}>
                                        <DatePicker
                                            autoOk
                                            className={classes.inputNuevaBanda}
                                            name="fechaHasta"
                                            id="fechaHasta"
                                            value={fechaHasta}
                                            label="Fecha Hasta"
                                            format="dd/MM/yyyy"
                                            inputVariant="outlined"
                                            onChange={(fecha) => {
                                                setFechaHasta(fecha);
                                                formik.setFieldValue(
                                                    "fechaHasta",
                                                    format(fecha, "dd/MM/yyyy")
                                                );
                                            }}
                                            disableToolbar
                                            variant="inline"
                                        />
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            onClick={() => {
                                                setFechaHasta(null);
                                                formik.setFieldValue(
                                                    "fechaHasta",
                                                    ""
                                                );
                                            }}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                            variant="contained"
                                        >
                                            X
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={12}>
                                <Box mt={2}>
                                    <Button
                                        onClick={formik.handleSubmit}
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Buscar
                                    </Button>
                                    <Button
                                        onClick={resetForm}
                                        variant="contained"
                                        style={{
                                            backgroundColor: "#6C757D",
                                            color: "white",
                                            marginLeft: "1em",
                                        }}
                                    >
                                        Limpiar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
            <Grid item md={12}>
                <Card>
                    <div style={{ height: 400, width: "100%" }}>
                        <TablaMaterialUI
                            columnas={columns}
                            filas={rows}
                            sortModel={{
                                field: "id",
                                sort: "desc",
                            }}
                            cargando={cargandoLista}
                        />
                    </div>
                </Card>
            </Grid>
        </>
    );
}
export default ModuloListado;
